// rgba(225, 245, 255, 1)

import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useStrategyMapRowNameStyles = makeThemedStyles(
  "StrategyMapRowName",
  (theme) => ({
    root: {
      fontSize: "1.6em",
      lineHeight: "1.5em",
      color: "rgba(76, 81, 87, 1)",
      fontWeight: 600,
      letterSpacing: "0.05625px",
      height: "3.18em",
      maxWidth: "8.375em",
      minWidth: "8.375em",
      margin: "0",
    },
  })
);

const StrategyMapRowName = (props: React.PropsWithChildren<{}>) => {
  const styles = useStrategyMapRowNameStyles();
  return <div className={styles.root}>{props.children}</div>;
};

export default StrategyMapRowName;
